import { createReducer } from 'app-webtech-core/reducers/createReducer';
import {
  ONBOARD_DIALOG_HIDE,
  ONBOARD_DIALOG_SHOW,
  WAMSOON_SHOW,
  WAMNOW_SHOW,
  WAMNOW_HIDE,
  WAMSOON_HIDE,
  CHATNOW_HIDE,
  CHATNOW_SHOW,
  CHATSOON_HIDE,
  CHATSOON_SHOW,
} from '../actions/types';

import {
  wamDialogsOnboardDialogHideReducer,
  wamDialogsOnboardDialogShowReducer,
} from './onboardDialogVisibility';

import { wamDialogsWamNowHideReducer, wamDialogsWamNowShowReducer } from './wamNowVisibility';

import { wamDialogsWamSoonHideReducer, wamDialogsWamSoonShowReducer } from './wamSoonVisibility';

import {
  chatDialogsChatSoonHideReducer,
  chatDialogsChatSoonShowReducer,
} from './chatSoonVisibility';

import { chatDialogsChatNowHideReducer, chatDialogsChatNowShowReducer } from './chatNowVisibility';

export const defaultState = {
  showOnboardDialog: false,
};

export const wamDialogsReducer = createReducer(defaultState, {
  [ONBOARD_DIALOG_HIDE]: wamDialogsOnboardDialogHideReducer,
  [ONBOARD_DIALOG_SHOW]: wamDialogsOnboardDialogShowReducer,
  [WAMSOON_HIDE]: wamDialogsWamSoonHideReducer,
  [WAMSOON_SHOW]: wamDialogsWamSoonShowReducer,
  [WAMNOW_HIDE]: wamDialogsWamNowHideReducer,
  [WAMNOW_SHOW]: wamDialogsWamNowShowReducer,

  [CHATNOW_SHOW]: chatDialogsChatNowShowReducer,
  [CHATSOON_SHOW]: chatDialogsChatSoonShowReducer,
  [CHATNOW_HIDE]: chatDialogsChatNowHideReducer,
  [CHATSOON_HIDE]: chatDialogsChatSoonHideReducer,
});
